import React from 'react';
import { Container } from 'vendors/semantic-ui';

import { DescriptionLoader, TitleBlocLoader } from '../../components';
import styles from './our-customers-component.module.css';

export const OurCustomersLoader: React.FC = React.memo(() => {
    return (
        <div className={styles.container}>
            <div className={styles.titleBlocSection}>
                <TitleBlocLoader size="large" />
            </div>
            <Container>
                <div className={styles.descrptionSection}>
                    <DescriptionLoader fullwidth />
                </div>
            </Container>
        </div>
    );
});
